export default __webpack_public_path__ + "static/06_march_2021-6671ad5bafa3993013bd96b3a41ce5fa.png";